import { TQueryAllResult } from '../models/query-all-result.model';

export function getNodes<Type>(data: TQueryAllResult<Type>) {
    return data?.edges.map((item) => item.node);
}
